module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_19"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Joseph Pearce is a literary critic, a historian, and a Shakespeare scholar. He is the author of thirty books, including "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Tolkien: Man and Myth")]), _vm._v(" and "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Solzhenitsyn: A Soul in Exile")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7623b77f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_007.vue
// module id = 84
// module chunks = 0